export const levels = {
  1: {
    greyBlocks: [
      { id: 'grey1', position: [6, 7] },
      { id: 'grey2', position: [3, 6] },
      { id: 'grey3', position: [2, 2], rotated: true }
    ]
  },
  // 可以添加更多关卡配置
}

export const validateSolution = (board) => {
  // 检查是否所有格子都已填充（忽略预览和已放置方块的位置）
  for (let i = 0; i < 8; i++) {
    for (let j = 0; j < 8; j++) {
      const cell = board[i][j]
      if (!cell.blockId) {
        return {
          valid: false,
          message: '还有空格未填充'
        }
      }
    }
  }

  // 这里可以添加更多验证规则
  return {
    valid: true,
    message: '恭喜你完成了这一关！'
  }
} 